import '../../css/drivers/app.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { observer } from 'mobx-react'
import { ErrorBoundary } from '@sentry/react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import sentryConfig from '../lib/util/sentry-config'
import { responseStatusStore } from './stores/ResponseStatusStore'
import axiosInterceptors from './util/axiosInterceptors'
import StoresContext from './providers/storesContext'
import {
  HOME,
  MANUAL_SEARCH,
  CASE_DETAIL,
  SCAN_SEARCH,
  CASELESS_SEARCH,
  CASELESS_DETAIL,
  CASELESS_CHECKOUT,
  CASELESS_PAYMENT_SUCCESS, 
  CASELESS_SEARCH_LOCATION,
  MANUAL_SEARCH_AREA,
  MAINTENANCE_MODE,
  BOOTBOX_CHECKIN
} from './routing/paths'
import TopBar from './components/TopBar'
import Error404 from './scenes/Error404'
import SearchSwitch from './scenes/SearchSwitch'
import Error500 from '../lib/scenes/Error500'
import ManualSearch from './scenes/ManualSearch'
import CaselessSearch from './scenes/CaselessSearch'
import CaseSwitch from './scenes/CaseSwitch'
import ScanSearch from './scenes/ScanSearch'
import CaseDetailStore from './stores/CaseDetailStore'
import LicenseStore from './stores/LicenseStore'
import CaselessCheckoutCreditCard from './scenes/CaselessCheckout/CaselessCheckoutCreditCard'
import CaselessSuccessPayment from './scenes/CaselessCheckout/components/CaselessSuccessPayment'
import CaselessDetail from './scenes/CaselessDetail'
import MaintenanceMode from './scenes/MaintenanceMode'
import BootboxForm from './scenes/BootboxCheckIn'

const sharedStores = {
  caseDetailStore: new CaseDetailStore(),
  licenseStore: new LicenseStore()
}

sentryConfig()
axiosInterceptors()

const Main = observer(() => {
  if (responseStatusStore.error404) {
    return <Error404 />
  }

  if (responseStatusStore.error500) {
    return <Error500 />
  }

  return (
    <StoresContext.Provider value={sharedStores}>
      <ErrorBoundary fallback={<Error500 />}>
        <Router>
          <TopBar />
          <div className="relative w-full px-4 flex flex-col flex-1 pt-4 sm:w-drivers-container sm:mx-auto">
            <Switch>
              <Route exact path={HOME} component={SearchSwitch} />
              <Route exact path={BOOTBOX_CHECKIN} component={BootboxForm} />
              <Route exact path={SCAN_SEARCH} component={ScanSearch} />
              <Route exact path={MANUAL_SEARCH} component={ManualSearch} />
              <Route exact path={MAINTENANCE_MODE} component={MaintenanceMode} />
              <Route exact path={CASELESS_SEARCH} component={CaselessSearch} />
              <Route exact path={CASELESS_DETAIL} component={CaselessDetail} />
              <Route exact path={CASELESS_CHECKOUT} component={CaselessCheckoutCreditCard} />
              <Route exact path={CASELESS_PAYMENT_SUCCESS} component={CaselessSuccessPayment} />
              <Route path={CASE_DETAIL} component={CaseSwitch} />
              <Route path={CASELESS_SEARCH_LOCATION} component={CaselessSearch} />
              <Route path={MANUAL_SEARCH_AREA} component={ManualSearch} />
              <Route component={Error404} />
            </Switch>
          </div>
        </Router>
      </ErrorBoundary>
    </StoresContext.Provider>
  )
})

ReactDOM.render(<Main />, document.querySelector('#app'))
